import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import DateField from '../../../../Components/Form/components/DateField';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import DiagnosisSelectField from '../../../../Components/Base/Diagnosis/DiagnosisSelectField';
import InputField from '../../../../Components/Form/components/InputField';
import FormContainer from '../../../../Components/Form/FormContainer';
import { SelectValue } from '../../../../Components/Base/Select/Select';

export interface CSSZSickLeaveCertificateEndOfSickLeaveFormValues {
	incapacityEndDate: string;
	decisionDay: string;
	diagnosis: SelectValue;
	OSSA?: {
		decisionOfOSSA?: string;
		toDate?: string;
		decisionDay?: string;
	};
}

interface Props {
	onSubmit: (values: CSSZSickLeaveCertificateEndOfSickLeaveFormValues) => void;
	defaultValues?: DeepPartial<CSSZSickLeaveCertificateEndOfSickLeaveFormValues>;
}

const validationSchema = yup.object({
	incapacityEndDate: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateEndOfSickLeave.incapacityEndDate',
		),
	decisionDay: yup
		.string()
		.nullable()
		.required('validation.CSSZSickLeaveCertificateEndOfSickLeave.decisionDay'),
	diagnosis: yup
		.object({
			value: yup
				.string()
				.required(
					'validation.CSSZSickLeaveCertificateEndOfSickLeave.diagnosis',
				),
			label: yup.string(),
		})
		.required('validation.CSSZSickLeaveCertificateEndOfSickLeave.diagnosis')
		.typeError('validation.CSSZSickLeaveCertificateEndOfSickLeave.diagnosis'),
});

const CSSZSickLeaveCertificateEndOfSickLeaveForm: React.FC<Props> = ({
	onSubmit,
	defaultValues,
}) => {
	const formMethods = useForm({
		defaultValues,
		resolver: yupResolver(validationSchema),
	});

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='row'>
				<div className='col-4'>
					<DateField
						name='incapacityEndDate'
						label='component.CSSZSickLeaveCertificateEndOfSickLeave.incapacityEndDate'
						isRequired
						isWrapped
					/>
				</div>
				<div className='col-4'>
					<DateField
						name='decisionDay'
						label='component.CSSZSickLeaveCertificateEndOfSickLeave.decisionDay'
						isRequired
						isWrapped
					/>
				</div>
				<div className='col-4'>
					<DiagnosisSelectField
						name='diagnosis'
						label='component.CSSZSickLeaveCertificateEndOfSickLeave.diagnosis'
						isRequired
						isWrapped
					/>
				</div>
			</div>
			<div className='mt-3'>
				<SubmitButton onSubmit={onSubmit} />
			</div>
		</FormWrapper>
	);
};

export default CSSZSickLeaveCertificateEndOfSickLeaveForm;
